module.exports = __webpack_public_path__ + "static/0facc856c6bd1613df2e06b0f52aff5d24c2170cd19ae38d4e4d3042d0d113f1-c07b9892d0888745f66ab58c00e7e0df.png";